import { useQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { useGetRegisterIdParam } from '@/modules/common/hooks/useGetRegisterIdParam.ts';
import {
  GetIssuedCapitalOverTimeBySecuritiesV1SrChartsIssuerIssuedCapitalOverTimeBySecuritiesGetParams,
  GetIssuedCapitalOvertimeChartBySecuritiesResponse,
  GetRegisterClassUnitsResponse,
  GetRegisterClassUnitsV1SrRegisterClassUnitsGetParams,
} from 'api';

export const CHARTS_ISSUER_ISSUED_CAPITAL_OVERTIME_QUERY_KEY =
  'vestra/charts-issuer-issued-capital-over-time';
export const ISSUER_REGISTER_CLASSES_UNITS_QUERY_KEY = 'vestra/issuer-register-classes-units';

export const useIssuedCapitalOverTimeQuery = (
  payload: GetIssuedCapitalOverTimeBySecuritiesV1SrChartsIssuerIssuedCapitalOverTimeBySecuritiesGetParams = {},
  disabled = false,
) => {
  const registerId = useGetRegisterIdParam();

  return useQuery<GetIssuedCapitalOvertimeChartBySecuritiesResponse>({
    queryKey: [
      CHARTS_ISSUER_ISSUED_CAPITAL_OVERTIME_QUERY_KEY,
      registerId,
      JSON.stringify(payload),
    ],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async () => {
      const response =
        await api.v1.getIssuedCapitalOverTimeBySecuritiesV1SrChartsIssuerIssuedCapitalOverTimeBySecuritiesGet(
          payload,
        );
      return response.data;
    },
    // keepPreviousData: true,
    retry: 2,
    enabled: !disabled,
  });
};

export const useRegisterClassesUnitsQuery = (
  payload: GetRegisterClassUnitsV1SrRegisterClassUnitsGetParams = {},
  disabled = false,
) => {
  const registerId = useGetRegisterIdParam();

  return useQuery<GetRegisterClassUnitsResponse>({
    queryKey: [ISSUER_REGISTER_CLASSES_UNITS_QUERY_KEY, registerId, JSON.stringify(payload)],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async () => {
      const response = await api.v1.getRegisterClassUnitsV1SrRegisterClassUnitsGet(payload);
      return response.data;
    },
    // keepPreviousData: true,
    retry: 2,
    enabled: !disabled,
  });
};
